import i18n from 'i18next';
import { OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';
import { getTotalPrice } from '../../../utils';
import { getActualProduct } from '../../../ServiceSummary/utils';
import { baggageOptionItemFactory } from './baggageOptionItemFactory';
import { mealOptionItemFactory } from './mealOptionItemFactory';
export function additionalOptionItemFactory({ key, travellerId, service, gdsServiceType, segments, products = [] }) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const isAllSegments = key === 'allSegments';
    const serviceId = service.servicePayload.id;
    const gdsService = service.gdsService;
    const count = service.number;
    const confirmedCount = (_a = service.servicePayload) === null || _a === void 0 ? void 0 : _a.confirmedCount;
    const included = confirmedCount !== undefined && count === confirmedCount;
    const segmentsCount = segments.length;
    const segment = !isAllSegments && segments.find(segment => segment.id === key);
    const direction = segment
        ? `${segment.departure.airport.iata} – ${segment.arrival.airport.iata}`
        : i18n.t('All flights', { ns: 'Cart' });
    switch (gdsServiceType) {
        case 'Seat': {
            const seat = service.servicePayload;
            const included = seat.isConfirmed && !seat.onRequest;
            return {
                id: seat.number,
                name: `${direction}, ${seat.number}`,
                price: ((_b = seat.seatServices) === null || _b === void 0 ? void 0 : _b.length)
                    ? getTotalPrice(seat.seatServices, service => service.price)
                    : seat.price,
                included,
                status: (_c = seat.product) === null || _c === void 0 ? void 0 : _c.status,
                deleteMeta: !included
                    ? {
                        serviceId: seat.number,
                        passengerId: travellerId,
                        segmentId: key,
                        type: OrderAdditionalServiceGdsServiceServiceType.Meal
                    }
                    : null
            };
        }
        case 'Baggage':
        case 'Animal':
            const commonServiceObj = {
                key,
                travellerId,
                count,
                confirmedCount,
                segmentsCount,
                products,
                gdsService: gdsService
            };
            if (confirmedCount && count !== confirmedCount) {
                return [
                    baggageOptionItemFactory(Object.assign(Object.assign({}, commonServiceObj), { groupType: 'confirmed' })),
                    baggageOptionItemFactory(Object.assign(Object.assign({}, commonServiceObj), { groupType: 'booked' }))
                ];
            }
            return baggageOptionItemFactory(Object.assign(Object.assign({}, commonServiceObj), { groupType: 'all' }));
        case 'Meal': {
            const commonServiceFactoryObj = {
                key,
                serviceId,
                travellerId,
                direction,
                count,
                confirmedCount,
                products,
                gdsService: gdsService
            };
            if (confirmedCount && count !== confirmedCount) {
                return [
                    mealOptionItemFactory(Object.assign(Object.assign({}, commonServiceFactoryObj), { groupType: 'confirmed' })),
                    mealOptionItemFactory(Object.assign(Object.assign({}, commonServiceFactoryObj), { groupType: 'booked' }))
                ];
            }
            return mealOptionItemFactory(commonServiceFactoryObj);
        }
        case 'BusinessLounge': {
            // const name =
            // 	services.length === 1 && gdsService ? gdsService.name : i18n.t('Business lounge', { ns: 'Checkout' });
            const name = gdsService ? gdsService.name : i18n.t('Business lounge', { ns: 'Checkout' });
            return {
                name,
                id: serviceId,
                price: gdsService.price,
                status: (_d = getActualProduct(products)) === null || _d === void 0 ? void 0 : _d.status,
                included,
                deleteMeta: !included
                    ? {
                        serviceId,
                        passengerId: travellerId,
                        segmentId: key,
                        type: OrderAdditionalServiceGdsServiceServiceType.BusinessLounge,
                        allSegments: isAllSegments
                    }
                    : null
            };
        }
        case 'Transfer': {
            const price = gdsService.price;
            if (isAllSegments) {
                price.amount *= segmentsCount;
            }
            return {
                id: serviceId,
                name: gdsService.name,
                segment: key,
                included,
                price,
                status: (_e = getActualProduct(products)) === null || _e === void 0 ? void 0 : _e.status,
                deleteMeta: !included
                    ? {
                        serviceId,
                        passengerId: travellerId,
                        segmentId: key,
                        type: OrderAdditionalServiceGdsServiceServiceType.Vip,
                        allSegments: isAllSegments
                    }
                    : null
            };
        }
        case 'Upgrade': {
            return {
                id: serviceId,
                name: direction,
                included,
                price: service.servicePayload.price,
                status: (_f = getActualProduct(products)) === null || _f === void 0 ? void 0 : _f.status,
                deleteMeta: !included
                    ? {
                        serviceId,
                        passengerId: travellerId,
                        segmentId: key,
                        type: OrderAdditionalServiceGdsServiceServiceType.Vip,
                        allSegments: isAllSegments
                    }
                    : null
            };
        }
        case 'Sms': {
            const price = Object.assign(Object.assign({}, gdsService.price), { amount: ((_h = (_g = gdsService.price) === null || _g === void 0 ? void 0 : _g.amount) !== null && _h !== void 0 ? _h : 0) * segmentsCount });
            return {
                id: serviceId,
                name: gdsService.name,
                price,
                included,
                deleteMeta: !included
                    ? {
                        serviceId,
                        passengerId: travellerId,
                        segmentId: key,
                        allSegments: isAllSegments
                    }
                    : null
            };
        }
        default:
            return null;
    }
}
